import React from 'react'
import {useSelector} from 'react-redux'
import {ProfileDetails} from '../../Common/ProfileDetails'
import {SignInMethod} from '../../Common/SignInMethod'

export function Settings() {
  return (
    <>
      <ProfileDetails />
      <SignInMethod />
      {/* {user=='user' && <EmailPreferences />} */}
    </>
  )
}
